import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetCreditScoreList } from "../../store/creditScoreAtom";
import { rankColor } from "./creditScoreRank";

const rankOptions = ["Exceptional", "Very Good", "Good", "Fair", "Poor"];

function CreditScoreScroll(props) {
  const creditScoreStore = GetCreditScoreList();
  const { id } = useParams();
  const [rank, setRank] = useState("");
  const [pageSize, setPageSize] = useState(20);

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const list = creditScoreStore.credit_score ?? [];
    const filtered = rank ? list.filter((item) => item?.score_rank === rank) : list;
    setTableData(filtered.slice(0, pageSize));
  }, [creditScoreStore, rank, pageSize]);

  return (
    <>
      <section className="w-full min-w-[170px] max-w-[200px]">
        <div className="w-full">
          <div className="ml-0.5 mt-1 mr-2">
            <select
              value={rank}
              onChange={(e) => setRank(e.target.value)}
              className="mb-2 w-full max-w-xs text-xs text-gray-700 bg-white border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
            >
              <option value="">All</option>
              {rankOptions.map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </select>
          </div>

          <div className="h-[calc(100vh-60px)] w-full overflow-y-scroll scrollbar-thin scrollbar-track-gray-200">
            {tableData?.map((item) => (
              <div key={item?.customer_id} onClick={() => props.viewItemDetails(item?.customer_id)}>
                <div
                  className={`border-b-[1px] border-gray-300 cursor-pointer transition px-2 py-2 ${
                    String(id) === String(item?.customer_id)
                      ? "bg-gray-200 border-b-blue-400"
                      : "bg-white hover:!bg-gray-100"
                  }`}
                >
                  <div className="flex items-start justify-between">
                    <span title={item?.customer_full_name} className="text-sm text-gray-700 truncate max-w-[110px]">
                      {item?.customer_full_name}
                    </span>
                    <span
                      className={`text-[11px] ${
                        item?.customer_status_name === "Active" ? "text-green-600 font-medium" : "text-gray-400"
                      }`}
                    >
                      {item?.customer_status_name}
                    </span>
                  </div>

                  <div className="mt-1 flex flex-row items-center justify-between text-sm font-bold text-gray-800">
                    <span>{item?.final_score}</span>
                    <span className={`text-[11px] ${rankColor[item?.score_rank] ?? ""}`}>{item?.score_rank}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="clearfix mt-3 ml-2 text-center">
          <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </section>
    </>
  );
}

export default CreditScoreScroll;
